import nikhil from "./../images/nikhil.jpg";
import tirth from "./../images/nikhil.jpg";
import kashyap from "./../images/kashyap.jpg";
import edzil from "./../images/edzil.jpg";
import parth from "./../images/parth.jpg";

export const speakers = [
  {
    name: "Kashyap Patel",
    title: "Mentor",
    team: "Parks and Recreation",
    basedIn: "Mumbai, IN",
    shortBio:
      "Expert in Hardware",
    avatar: kashyap,
    pronouns: "he/him",
  },
  {
    name: "Edzil Misquitta",
    title: "Member",
    team: "Parks and Recreation",
    basedIn: "India",
    shortBio: "Expert in Web Development",
    avatar: edzil,
    pronouns: "he/him",
  },

  {
    name: "Parth Salian",
    title: "Professor",
    team: "Tommy's World",
    basedIn: "Snake Hole Lounge",
    shortBio:
      "Expert in Android Development",
    avatar: parth,
    pronouns: "he/him",
  },
  {
    name: "Tirth Rambhia",
    title: "Professor",
    team: "Team tirth",
    basedIn: "Mumbai, India",
    shortBio: "Expert in React",
    avatar: tirth,
    pronouns: "he/him",
  },
  {
    name: "Nikhil Parab",
    title: "Member",
    team: "All of Dunder Mifflin",
    basedIn: "Mumbai, India",
    shortBio:
      "Framework Engineer",
    avatar: nikhil,
    pronouns: "he/him",
  },
  {
    name: "Kashyap Patel",
    title: "Mentor",
    team: "TLDR",
    basedIn: "Mumbai, India",
    shortBio:
      "Machine Learning Engineer",
    avatar: kashyap,
    pronouns: "he/him",
  },
];
